import React from 'react';

const PayPerVideoPricing = () => {
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 px-4 py-4 sm:px-5 sm:py-5">

      {/* Header */}
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="w-6 h-6 rounded-full bg-brand-red flex items-center justify-center">
            <span className="text-white text-[9px] leading-none">►</span>
          </div>
          <div>
            <h2 className="text-sm font-bold text-gray-900">Pay-Per-Video</h2>
            <p className="text-[10px] text-gray-500">No subscription needed</p>
          </div>
        </div>

        <span className="px-2 py-0.5 rounded-full text-[10px] font-medium bg-gray-100 text-gray-700">
          Flexible
        </span>
      </div>

      {/* Price tiers */}
      <div className="grid grid-cols-3 gap-2 text-center mb-3">
        <div>
          <div className="text-[9px] font-semibold text-gray-500 uppercase">≤30 min</div>
          <div className="text-lg font-extrabold text-gray-900">$3.99</div>
        </div>
        <div>
          <div className="text-[9px] font-semibold text-gray-500 uppercase">30–60 min</div>
          <div className="text-lg font-extrabold text-gray-900">$5.99</div>
        </div>
        <div>
          <div className="text-[9px] font-semibold text-gray-500 uppercase">60–120 min</div>
          <div className="text-lg font-extrabold text-gray-900">$9.99</div>
        </div>
      </div>

      <hr className="border-gray-200 mb-2" />

      {/* Bullets */}
      <ul className="space-y-1 text-[11px] text-gray-700">
        <li className="flex items-start gap-1.5">
          <span className="w-3.5 h-3.5 mt-0.5 bg-green-100 text-green-600 text-[7px] rounded-full flex items-center justify-center">✔</span>
          <span>Pay only when needed</span>
        </li>
        <li className="flex items-start gap-1.5">
          <span className="w-3.5 h-3.5 mt-0.5 bg-green-100 text-green-600 text-[7px] rounded-full flex items-center justify-center">✔</span>
          <span>Works even on free plan</span>
        </li>
        <li className="flex items-start gap-1.5">
          <span className="w-3.5 h-3.5 mt-0.5 bg-green-100 text-green-600 text-[7px] rounded-full flex items-center justify-center">✔</span>
          <span>Videos saved to storage</span>
        </li>
      </ul>

    </div>
  );
};

export default PayPerVideoPricing;
